export default __webpack_public_path__ + "static/media/17_Icono_Cerrar_sesion.6b3a8651.svg";